/**
 * @fileoverview POST handler for the "/engagement/segments/clone" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsCloneCacheKeys } from "./constants";
import type { PostEngagementSegmentsCloneProps, EngagementSegmentsCloneResult } from "./types";

export const postEngagementSegmentsClone = reactQueryMutationAdapter(
  engagementSegmentsCloneCacheKeys,
  (props: PostEngagementSegmentsCloneProps): Promise<EngagementSegmentsCloneResult> => {
    return fetch("/engagement/segments/clone", "POST", props);
  }
);
